/**
 * Determines whether a passed value is nullish (`null` or `undefined`).
 * Equivalent to the disallowed Javascript `== null` check.
 */
export function isNullish<T>(value: T | null | undefined): value is null | undefined {
  return value === null || value === undefined;
}

/**
 * Determines whether a passed value is non-nullish (not `null` or `undefined`).
 * Equivalent to the disallowed Javascript `!= null` check.
 */
export function nonNullish<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

/**
 * Determines whether a number is a finite number..
 */
export function isFiniteNumber(value: unknown): value is number | `${number}` {
  if (typeof value === 'number') {
    return Number.isFinite(value);
  }

  if (typeof value === 'string') {
    const s = value.trim();
    if (s === '') {
      return false;
    }
    const n = Number(s);
    return Number.isFinite(n);
  }

  return false;
}
